<button mat-button [matMenuTriggerFor]="menu">Ver Reportes</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item [routerLink]="['/reporteDeudaPeriodoContrato']"
    *appRole="['PeriodosContrato.ReporteDeudaPeriodoContrato']">Reporte de deuda de periodos</button>
  <button mat-menu-item [routerLink]="['/reportePropietarioMensual']"
    *appRole="['PeriodosContrato.AlquileresPropietarioMesaMes']">Alquileres por propietario (mes a mes)</button>
</mat-menu>
<br>

<div *appRole="['PeriodosContrato.Ver']">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        Filtros de Búsqueda
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-lg-2">
            <app-buscar-contrato [entityInput]="$any(contratoDetailDto)" (eventEntity)="selectContrato($event)"></app-buscar-contrato>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>date_range</mat-icon>
              <mat-label>Mes Desde</mat-label>
              <mat-select formControlName="PeriodoMesDesde">
                <mat-option [value]="1">Enero</mat-option>
                <mat-option [value]="2">Febrero</mat-option>
                <mat-option [value]="3">Marzo</mat-option>
                <mat-option [value]="4">Abril</mat-option>
                <mat-option [value]="5">Mayo</mat-option>
                <mat-option [value]="6">Junio</mat-option>
                <mat-option [value]="7">Julio</mat-option>
                <mat-option [value]="8">Agosto</mat-option>
                <mat-option [value]="9">Septiembre</mat-option>
                <mat-option [value]="10">Octubre</mat-option>
                <mat-option [value]="11">Noviembre</mat-option>
                <mat-option [value]="12">Diciembre</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>event</mat-icon>
              <mat-label>Año Desde</mat-label>
              <input type="number" matInput formControlName="PeriodoAnioDesde" [min]="2020" [max]="2035">
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>date_range</mat-icon>
              <mat-label>Mes Hasta</mat-label>
              <mat-select formControlName="PeriodoMesHasta">
                <mat-option [value]="1">Enero</mat-option>
                <mat-option [value]="2">Febrero</mat-option>
                <mat-option [value]="3">Marzo</mat-option>
                <mat-option [value]="4">Abril</mat-option>
                <mat-option [value]="5">Mayo</mat-option>
                <mat-option [value]="6">Junio</mat-option>
                <mat-option [value]="7">Julio</mat-option>
                <mat-option [value]="8">Agosto</mat-option>
                <mat-option [value]="9">Septiembre</mat-option>
                <mat-option [value]="10">Octubre</mat-option>
                <mat-option [value]="11">Noviembre</mat-option>
                <mat-option [value]="12">Diciembre</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>event</mat-icon>
              <mat-label>Año Hasta</mat-label>
              <input type="number" matInput formControlName="PeriodoAnioHasta" [min]="2020" [max]="2035">
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <ngx-spinner [zIndex]="100" name="spBusquedaTipoAjusteContrato" bdColor="rgba(255,255,255,0.8)"
                size="small" color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
              <mat-label>Tipos de Ajuste</mat-label>
              <mat-select placeholder="Seleccione opcion" multiple formControlName="TiposAjusteContrato">
                <mat-option [value]="tipoAjusteContrato.id" selected=true
                  *ngFor="let tipoAjusteContrato of lstTiposAjusteContrato;let i=index;trackBy:trackByItems"
                  [matTooltip]="tipoAjusteContrato.descripcion">
                  {{ tipoAjusteContrato.acronimo | uppercase }}</mat-option>
              </mat-select>
              <mat-error *ngIf="f.TiposAjusteContrato.errors?.required">Este campo es <strong>requerido</strong>.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <ngx-spinner [zIndex]="100" name="spBusquedaEstadosContrato" bdColor="rgba(255,255,255,0.8)" size="small"
                color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
              <mat-label>Estados de Contrato</mat-label>
              <mat-select placeholder="Seleccione opcion" multiple formControlName="EstadosContrato">
                <mat-option [value]="estadoContrato.id"
                  *ngFor="let estadoContrato of lstEstadosContrato;let i=index;trackBy:trackByItems"
                  [matTooltip]="estadoContrato.descripcion">
                  {{ estadoContrato.descripcion | titlecase }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="checkedFiltroAvanzado">
          <div class="col-lg-2" *ngIf="checkedFiltroAvanzado">
            <mat-form-field class="full-width">
              <mat-label>Fecha Vencimiento</mat-label>
              <mat-date-range-input [rangePicker]="pickerFechaVencimiento">
                <input matStartDate [disabled]="true" formControlName="FechaVencimientoDesde" appDateFormat="DD/MM/YYYY"
                  placeholder="Fecha desde" />
                <input matEndDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaVencimientoHasta"
                  placeholder="Fecha hasta" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerFechaVencimiento"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerFechaVencimiento disabled="false"></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="col-lg-2" *ngIf="checkedFiltroAvanzado">
            <mat-form-field class="full-width">
              <mat-label>Fechas de Ajuste</mat-label>
              <mat-date-range-input [rangePicker]="pickerFechaAjuste">
                <input matStartDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaAjusteDesde"
                  placeholder="Fecha desde" />
                <input matEndDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaAjusteHasta"
                  placeholder="Fecha hasta" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerFechaAjuste"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerFechaAjuste disabled="false"></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="col-lg-2" *ngIf="checkedFiltroAvanzado">
            <mat-form-field class="full-width">
              <mat-label>Fechas de Liquidación</mat-label>
              <mat-date-range-input [rangePicker]="pickerFechaLiquidacion">
                <input matStartDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaLiquidacionDesde"
                  placeholder="Fecha desde" />
                <input matEndDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaLiquidacionHasta"
                  placeholder="Fecha hasta" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerFechaLiquidacion"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerFechaLiquidacion disabled="false"></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="col-lg-2" *ngIf="checkedFiltroAvanzado">
            <mat-form-field class="full-width">
              <mat-label>Fechas de Pago</mat-label>
              <mat-date-range-input [rangePicker]="pickerFechaPago">
                <input matStartDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaPagoDesde"
                  placeholder="Fecha desde" />
                <input matEndDate [disabled]="true" appDateFormat="DD/MM/YYYY" formControlName="FechaPagoHasta"
                  placeholder="Fecha hasta" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="pickerFechaPago"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerFechaPago disabled="false"></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="col-lg-3" *ngIf="checkedFiltroAvanzado">
            <app-buscar-persona-propietaria #buscarPropietarioRef (eventEntity)="selectPropietario($event)"></app-buscar-persona-propietaria>
            <mat-chip-list *ngIf="propietariosSeleccionados.length">
              <mat-chip *ngFor="let propietario of propietariosSeleccionados"
                (removed)="removePropietario(propietario)">
                {{ propietario.descripcion }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <button mat-stroked-button color="primary" [disabled]="!form.valid" (click)="filtrar()">
              <mat-icon>filter_alt</mat-icon>
              Filtrar</button>&nbsp; &nbsp;
            <mat-slide-toggle class="example-margin" [checked]="checkedFiltroAvanzado"
              (change)="filtrosAvanzados($event)" color="primary">
              Filtros Avanzados
            </mat-slide-toggle>&nbsp; &nbsp;
            <button mat-stroked-button color="primary" (click)="clearDateControls()">
              <mat-icon>clear_all</mat-icon>
              Limpiar</button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">

    <!-- ============ RESUMEN DE COBRANZA Y LIQUIDACIÓN ============ -->
    <div class="resumen-cobranza" *ngIf="data">

      <!-- Cobranza al inquilino -->
      <div class="resumen-grupo">
        <div class="resumen-grupo-titulo">
          <mat-icon color="primary">request_quote</mat-icon>
          <span>Cobranza al inquilino</span>
          <button mat-icon-button class="btn-ayuda" (click)="abrirAyudaTotales('inquilino')"
            matTooltip="Ver qué contempla cada total">
            <mat-icon>info_outline</mat-icon>
          </button>
        </div>

        <div class="resumen-items">
          <div class="resumen-item">
            <span class="resumen-label">Total devengado</span>
            <span class="resumen-valor">{{ totalDevengado | currency }}</span>
            <span class="resumen-ayuda">Períodos ya vencidos</span>
          </div>

          <div class="resumen-item">
            <span class="resumen-label">Total cobrado</span>
            <span class="resumen-valor ok">{{ totalPagado | currency }}</span>
            <span class="resumen-ayuda">Con fecha de pago</span>
          </div>

          <div class="resumen-item">
            <span class="resumen-label">Deuda del inquilino</span>
            <span class="resumen-valor" [class.alerta]="deudaInquilino > 0">{{ deudaInquilino | currency }}</span>
            <span class="resumen-ayuda">
              Vencido e impago
              <ng-container *ngIf="cantidadPeriodosEnMora > 0">
                &mdash; {{ cantidadPeriodosEnMora }} período{{ cantidadPeriodosEnMora > 1 ? 's' : '' }}
              </ng-container>
            </span>
          </div>

          <div class="resumen-item">
            <span class="resumen-label">Total a cobrar</span>
            <span class="resumen-valor">{{ totalACobrar | currency }}</span>
            <span class="resumen-ayuda">Impago, incluye no vencidos</span>
          </div>
        </div>
      </div>

      <!-- Liquidación al propietario -->
      <div class="resumen-grupo resumen-grupo-propietario">
        <div class="resumen-grupo-titulo">
          <mat-icon color="primary">account_balance_wallet</mat-icon>
          <span>Liquidación al propietario</span>
          <button mat-icon-button class="btn-ayuda" (click)="abrirAyudaTotales('propietario')"
            matTooltip="Ver qué contempla cada total">
            <mat-icon>info_outline</mat-icon>
          </button>
        </div>

        <div class="resumen-items">
          <div class="resumen-item">
            <span class="resumen-label">Total liquidado</span>
            <span class="resumen-valor ok">{{ totalLiquidado | currency }}</span>
            <span class="resumen-ayuda">Con fecha de liquidación</span>
          </div>

          <!-- El criterio depende del tipo de liquidación del contrato, por eso
               la ayuda cambia según lo que haya en el filtro -->
          <div class="resumen-item">
            <span class="resumen-label">Total por liquidar</span>
            <span class="resumen-valor" [class.alerta]="totalPorLiquidar > 0">{{ totalPorLiquidar | currency }}</span>
            <span class="resumen-ayuda">
              <ng-container *ngIf="hayLiquidacionReal && !hayLiquidacionFicticia">Cobrado y sin liquidar</ng-container>
              <ng-container *ngIf="!hayLiquidacionReal && hayLiquidacionFicticia">Devengado y sin liquidar</ng-container>
              <ng-container *ngIf="hayLiquidacionReal && hayLiquidacionFicticia">Liquidable hoy, según cada contrato</ng-container>
            </span>
          </div>

          <!-- Sólo tiene sentido en liquidación real: en la ficticia lo impago
               ya cuenta como liquidable -->
          <div class="resumen-item" *ngIf="hayLiquidacionReal">
            <span class="resumen-label">Devengado sin cobrar</span>
            <span class="resumen-valor">{{ devengadoSinCobrarNiLiquidar | currency }}</span>
            <span class="resumen-ayuda">Vencido, impago y sin liquidar</span>
          </div>

          <div class="resumen-item total-control">
            <span class="resumen-label">Total períodos</span>
            <span class="resumen-valor">{{ totalPeriodos | currency }}</span>
            <span class="resumen-ayuda">Todos, vencidos y futuros</span>
          </div>
        </div>

        <!-- Que el número dependa del tipo de contrato no puede quedar implícito -->
        <div class="aviso-tipo-liquidacion" *ngIf="hayLiquidacionReal || hayLiquidacionFicticia">
          <mat-icon>info_outline</mat-icon>
          <span *ngIf="hayLiquidacionReal && !hayLiquidacionFicticia">
            Liquidación <b>real</b>: sólo se rinde lo que el inquilino pagó.
          </span>
          <span *ngIf="!hayLiquidacionReal && hayLiquidacionFicticia">
            Liquidación <b>ficticia</b>: se le rinde al propietario aunque el inquilino no haya pagado.
          </span>
          <span *ngIf="hayLiquidacionReal && hayLiquidacionFicticia">
            El filtro mezcla contratos de liquidación <b>real</b> y <b>ficticia</b>. Cada período se cuenta con el criterio del suyo.
          </span>
        </div>

        <!-- Apertura del Total liquidado según si el inquilino llegó a pagar -->
        <div class="resumen-subtitulo">Del total liquidado</div>

        <div class="resumen-items">
          <div class="resumen-item">
            <span class="resumen-label">Liquidado y cobrado</span>
            <span class="resumen-valor ok">{{ liquidadoYCobrado | currency }}</span>
            <span class="resumen-ayuda">Se liquidó y el inquilino pagó</span>
          </div>

          <div class="resumen-item">
            <span class="resumen-label">Liquidado sin cobrar</span>
            <span class="resumen-valor" [class.alerta]="liquidadoSinCobrar > 0">{{ liquidadoSinCobrar | currency }}</span>
            <span class="resumen-ayuda">Se liquidó y el inquilino no pagó</span>
          </div>

        </div>
      </div>

    </div>

    <div class="row" [hidden]=!data>
      <div class="col-lg-3">
        <mat-form-field class="example-full-width">
          <mat-label>Buscar contrato</mat-label>
          <input matInput type="search" (keyup)="applyFilter($event)">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <ngx-spinner [zIndex]=100 bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
      [fullScreen]="false">
    </ngx-spinner>

    <table mat-table [dataSource]="dataSource" [hidden]=!data table matSort matSortStart="asc" class="mat-elevation-z8">

      <ng-container matColumnDef="contrato">
        <mat-header-cell mat-header-cell *matHeaderCellDef> Contrato </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element">
          <a [routerLink]="['/contratos',element.contrato?.id]" #tooltip="matTooltip" matTooltipPosition="right"
            matTooltip="Ver"><span>{{element.contrato.descripcion | titlecase}}</span></a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="periodo">
        <mat-header-cell mat-header-cell *matHeaderCellDef> Periodo </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element"> {{element.periodoMes}}-{{element.periodoAnio}}/{{element.periodo}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaVencimiento">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Vto. </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" [ngClass]="{'vencimiento-rojo': isVencidoSinPago(element)}">
          {{element.fechaVencimiento | date:"dd/MM/yyyy"}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaAjuste">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Ajuste </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element"> {{element.fechaAjuste | date:"dd/MM/yyyy"}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="valorAjuste">
        <mat-header-cell mat-header-cell *matHeaderCellDef> Valor Ajuste </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element"> {{ element.valorAjuste | number:'1.3-3' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="indiceAjusteContrato">
        <mat-header-cell mat-header-cell *matHeaderCellDef> Indice </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element">
          <span
            [matTooltip]="'Valor: '+ element.indiceAjusteContrato?.valor+ '\n' + 'Fecha: ' + element.indiceAjusteContrato?.fecha  + '\n' + 'Descripción: ' + element.indiceAjusteContrato?.tipoAjusteContrato.descripcion | titlecase"
            matTooltipClass="toolTipsClass">
            {{element.indiceAjusteContrato?.tipoAjusteContrato.acronimo | uppercase}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="importeAlquiler">
        <mat-header-cell mat-header-cell *matHeaderCellDef> Importe Alq. </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element"> {{element.importeAlquiler | currency}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaPago">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Pago </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element"> {{element.fechaPago | date:"dd/MM/yyyy"}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaLiquidacion">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Liquidación </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element"> {{element.fechaLiquidacion | date:"dd/MM/yyyy"}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="accion">
        <mat-header-cell mat-header-cell *matHeaderCellDef> Acción </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let periodo" class="action-link">
          <button mat-icon-button [matMenuTriggerFor]="menuAccion" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menuAccion="matMenu">
            <button mat-menu-item (click)="openDialog(periodo)" *appRole="['PeriodosContrato.Ver']">
              <mat-icon>visibility</mat-icon>
              <span>Ver</span>
            </button>
            <button mat-menu-item (click)="openDialogEditar(periodo)" *appRole="['PeriodosContrato.Modificar']">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </table>

    <app-sin-datos [hidden]=data></app-sin-datos>

    <mat-paginator showFirstLastButtons class="paginator" [hidden]=!data [pageSize]="50"
      [pageSizeOptions]="[5, 10, 20,50,100,200]">
    </mat-paginator>
  </mat-card>
</div>
